import { render, staticRenderFns } from "./VerificationData.vue?vue&type=template&id=30dcd5cb&scoped=true&lang=pug&"
import script from "./VerificationData.vue?vue&type=script&lang=js&"
export * from "./VerificationData.vue?vue&type=script&lang=js&"
import style0 from "./VerificationData.vue?vue&type=style&index=0&id=30dcd5cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dcd5cb",
  null
  
)

export default component.exports